import React, { useEffect, useState } from "react";
import { ComplianceChartStatus } from "../../../../constants/Compliance.constants";
import styles from "./ComplianceOwnerDashboard.module.css";
import ComplianceStatusChart from "./ComplianceStatusChart";
const keys = [
    {
        id: 'col1',
        fields: [ComplianceChartStatus.ON_TIME, ComplianceChartStatus.LATE, ComplianceChartStatus.NON_COMPLIANT]
    },
    {
        id: 'col2',
        fields: [ComplianceChartStatus.DUE, ComplianceChartStatus.PENDING, ComplianceChartStatus.RECALLED]
    }
]

export default function OverallComplianceStatusCharts({ data }: any) {
    const { overall, notices } = data;

    return (
        <>
            <div className="mb-2 text-appprimary text-xl fw-bold">Overall Compliance Status</div>
            <div className={styles.statusCharts}>
                <div className="d-flex flex-column">
                    <div className="fw-bold">Total Activities: {(overall || {}).total || 0}</div>
                    <div className={styles.overallChartGrid}>
                        {
                            overall && keys.map(({ id, fields }: any) => {
                                return (
                                    <ComplianceStatusChart data={overall} fields={fields} key={id} type={id} />
                                )
                            })
                        }
                    </div>
                </div>

                <div className="d-flex flex-column">
                    <div className="fw-bold">Notices: {(notices || {}).total || 0}</div>
                    <div className={styles.noticesChartGrid}>
                        {
                            notices && <ComplianceStatusChart data={notices} fields={[...keys[0].fields, ...keys[1].fields]} key={'col1'} type={'col1'} />
                        }
                    </div>
                </div>
            </div>
        </>
    )
}